
export default {
	actions: {
	},
	mutations: {
	},
	state: () => ({
		politic: [
			{
				title: "Реквизиты Оператора",
				text: "для сайта https://zota-systems.ru и связанных цифровых сервисов\n" +
					"\n" +
					"<table>\n" +
					"  <tbody>\n" +
					"    <tr>\n" +
					"      <td>Оператор</td>\n" +
					"      <td>ООО «ЗОТА СИСТЕМС»</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>ОГРН</td>\n" +
					"      <td>1172468033165</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>ИНН/КПП</td>\n" +
					"      <td>2464136527/ 246301001</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Адрес</td>\n" +
					"      <td>г. Красноярск, ул. Калинина, 53, стр. 19, кабинет 1</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Сайт</td>\n" +
					"      <td>https://zota-systems.ru</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Телефон</td>\n" +
					"      <td>7 (391) 251-10-30</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Почта</td>\n" +
					"      <td>info@zota-systems.ru</td>\n" +
					"    </tr>\n" +
					"  </tbody>\n" +
					"</table>"
			},
			{
				title: "1. Общие положения",
				text: "1.1. Настоящая Политика в отношении обработки персональных данных (далее — Политика) определяет порядок и условия обработки персональных данных ООО «ЗОТА СИСТЕМС» (далее — Оператор), меры по обеспечению безопасности персональных данных, а также права субъектов персональных данных.\n" +
					"\n" +
					"1.2. Политика разработана в соответствии с Конституцией Российской Федерации, Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и иными нормативными правовыми актами Российской Федерации в области персональных данных.\n" +
					"\n" +
					"1.3. Политика применяется к персональным данным посетителей сайта https://zota-systems.ru пользователей программных продуктов, веб-приложений, мобильных приложений, личных кабинетов, форм обратной связи, служб поддержки, рассылок и иных цифровых сервисов Оператора (далее совместно — Сервисы), если в соответствующем сервисе не размещена отдельная политика.\n" +
					"\n" +
					"1.4. Политика не распространяется на сайты, приложения и сервисы третьих лиц, переход к которым может осуществляться по ссылкам из Сервисов. Оператор не отвечает за содержание и практики обработки персональных данных таких третьих лиц.\n" +
					"\n" +
					"1.5. Использование Сервисов само по себе не всегда означает согласие на обработку персональных данных. Согласие запрашивается отдельно в случаях, когда оно является необходимым правовым основанием обработки."
			},
			{
				title: "2. Основные термины",
				text: "<table>\n" +
					"  <thead>\n" +
					"    <tr>\n" +
					"      <th>Термин</th>\n" +
					"      <th>Значение</th>\n" +
					"    </tr>\n" +
					"  </thead>\n" +
					"  <tbody>\n" +
					"    <tr>\n" +
					"      <td>Персональные данные</td>\n" +
					"      <td>любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу.</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Обработка персональных данных</td>\n" +
					"      <td>любое действие или совокупность действий с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление и уничтожение.</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Автоматизированная обработка</td>\n" +
					"      <td>обработка персональных данных с помощью средств вычислительной техники.</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Предоставление персональных данных</td>\n" +
					"      <td>действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц.</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Распространение персональных данных</td>\n" +
					"      <td>действия, направленные на раскрытие персональных данных неопределенному кругу лиц.</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Файлы cookie</td>\n" +
					"      <td>небольшие фрагменты данных, сохраняемые браузером или приложением на устройстве пользователя для обеспечения работы, безопасности, настройки и анализа использования Сервисов.</td>\n" +
					"    </tr>\n" +
					"  </tbody>\n" +
					"</table>"
			},
			{
				title: "3. Принципы обработки персональных данных",
				text: "<ul>\n" +
					"<li>обработка осуществляется на законной и справедливой основе;</li>" +
					"<li>обработка ограничивается достижением конкретных, заранее определенных и законных целей;</li>" +
					"<li>не допускается объединение баз данных, обрабатываемых в несовместимых целях;</li>" +
					"<li>обрабатываются только персональные данные, соответствующие заявленным целям;</li>" +
					"<li>содержание и объем данных не являются избыточными;</li>" +
					"<li>обеспечиваются точность, достаточность и актуальность данных;</li>" +
					"<li>хранение осуществляется не дольше, чем этого требуют цели обработки или законодательство;</li>" +
					"<li>по достижении целей данные уничтожаются или обезличиваются, если иное не предусмотрено законом.</li>" +
					"</ul>"
			},
			{
				title: "4. Категории субъектов, цели, данные и основания обработки",
				text: "Оператор обрабатывает персональные данные в объеме, необходимом для соответствующей цели. Конкретный состав данных зависит от используемого Сервиса и действий пользователя.\n" +
					"\n" +
					"<table>\n" +
					"  <thead>\n" +
					"    <tr>\n" +
					"      <th>Категория / цель</th>\n" +
					"      <th>Персональные данные</th>\n" +
					"      <th>Правовое основание</th>\n" +
					"      <th>Срок обработки и хранения</th>\n" +
					"    </tr>\n" +
					"  </thead>\n" +
					"  <tbody>\n" +
					"    <tr>\n" +
					"      <td>Посетители Сайта: обеспечение работы и безопасности</td>\n" +
					"      <td>IP-адрес, дата и время доступа, сведения о браузере, ОС и устройстве, технические идентификаторы, журналы событий, необходимые cookie</td>\n" +
					"      <td>Законный интерес Оператора; исполнение требований законодательства</td>\n" +
					"      <td>До 12 месяцев, если более длительный срок не требуется для расследования инцидента или по закону</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Пользователи Сервисов: регистрация и личный кабинет</td>\n" +
					"      <td>ФИО или имя пользователя, телефон, e-mail, идентификатор учетной записи, пароль в виде криптографического хеша, история входов и действий</td>\n" +
					"      <td>Заключение и исполнение договора; согласие — когда требуется законом</td>\n" +
					"      <td>В течение использования учетной записи и до 3 лет после ее удаления, если иной срок не установлен законом или договором</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Клиенты и заказчики: оформление и исполнение заказа/договора</td>\n" +
					"      <td>ФИО, контакты, адрес доставки, сведения о заказе, платежный статус, реквизиты договора; платежные данные обрабатываются платежным провайдером, если прямо не указано иное</td>\n" +
					"      <td>Заключение и исполнение договора; исполнение обязанностей по бухгалтерскому и налоговому учету</td>\n" +
					"      <td>В сроки исполнения договора и обязательные сроки хранения документов по законодательству</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Обращения и техническая поддержка</td>\n" +
					"      <td>Имя, e-mail, телефон, содержание обращения, вложения, переписка, технические сведения об ошибке</td>\n" +
					"      <td>Согласие; исполнение договора; законный интерес в рассмотрении обращений и защите прав</td>\n" +
					"      <td>До 3 лет после завершения обращения, если более длительный срок не требуется для защиты прав</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Маркетинговые коммуникации</td>\n" +
					"      <td>Имя, e-mail, телефон, сведения о согласии и предпочтениях, статистика доставки и открытия сообщений</td>\n" +
					"      <td>Предварительное согласие субъекта</td>\n" +
					"      <td>До отзыва согласия либо прекращения рассылки</td>\n" +
					"    </tr>\n" +
					"    <tr>\n" +
					"      <td>Партнеры, представители контрагентов</td>\n" +
					"      <td>ФИО, должность, место работы, рабочие контакты, сведения о полномочиях, деловая переписка</td>\n" +
					"      <td>Заключение и исполнение договора; законный интерес в деловом взаимодействии</td>\n" +
					"      <td>В течение отношений и сроки хранения документов по законодательству</td>\n" +
					"    </tr>\n" +
					"  </tbody>\n" +
					"</table>\n" +
					"\n" +
					"Оператор не осуществляет целенаправленную обработку специальных категорий персональных данных и биометрических персональных данных пользователей Сервисов, если иное прямо не предусмотрено отдельным сервисом, законом и надлежащим правовым основанием."
			},
			{
				title: "5. Источники получения персональных данных",
				text: "<ul>\n" +
					"<li>непосредственно от субъекта при заполнении форм, регистрации, обращении в поддержку, заключении и исполнении договора;</li>" +
					"<li>автоматически при использовании Сервисов — с устройства, браузера, приложения, серверных журналов и cookie;</li>" +
					"<li>от контрагентов и партнеров при наличии законного основания и надлежащего информирования субъекта;</li>" +
					"<li>из общедоступных источников — только в случаях и пределах, допускаемых законодательством.</li>" +
					"</ul>"
			},
			{
				title: "6. Файлы cookie и технологии аналитики",
				text: "6.1. Сервисы могут использовать обязательные, функциональные и аналитические cookie. Обязательные cookie необходимы для работы, безопасности и сохранения пользовательской сессии. Иные cookie применяются при наличии предусмотренного законом основания и с учетом настроек пользователя.\n" +
					"\n" +
					"6.2. Пользователь может ограничить или удалить cookie в настройках браузера или устройства. Отключение обязательных cookie может привести к некорректной работе отдельных функций.\n" +
					"\n" +
					"6.3. Если Оператор подключает внешние системы веб-аналитики, рекламные платформы, виджеты или SDK, сведения о таких поставщиках, целях, категориях данных и применимых настройках должны быть раскрыты в интерфейсе управления cookie либо в отдельном перечне сервисов обработки."
			},
			{
				title: "7. Условия и способы обработки",
				text: "7.1. Обработка осуществляется с использованием средств автоматизации и, при необходимости, без их использования.\n" +
					"\n" +
					"7.2. Оператор совершает с персональными данными действия, необходимые для соответствующей цели: сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, предоставление, обезличивание, блокирование, удаление и уничтожение.\n" +
					"\n" +
					"7.3. Решения, порождающие юридические последствия для субъекта или иным образом затрагивающие его права и законные интересы, не принимаются исключительно на основании автоматизированной обработки, за исключением случаев, допускаемых законодательством и договором."
			},
			{
				title: "8. Передача и поручение обработки персональных данных",
				text: "8.1. Оператор может предоставлять персональные данные третьим лицам либо поручать им обработку только при наличии правового основания и в объеме, необходимом для заявленной цели:\n" +
					"<ul>\n" +
					"<li>провайдерам хостинга, облачной инфраструктуры, систем хранения данных и информационной безопасности;</li>" +
					"<li>поставщикам CRM, сервисов коммуникации, технической поддержки, электронной почты и аналитики;</li>" +
					"<li>платежным организациям, банкам, операторам фискальных данных, службам доставки и иным исполнителям договора;</li>" +
					"<li>профессиональным консультантам, аудиторам и представителям — при соблюдении конфиденциальности;</li>" +
					"<li>государственным органам и иным лицам — в случаях, предусмотренных законодательством.</li>" +
					"</ul>\n" +
					"\n" +
					"8.2. Договор с лицом, обрабатывающим данные по поручению Оператора, должен устанавливать цели, перечень данных и операций, требования конфиденциальности, безопасности, локализации, подтверждения соблюдения требований и уведомления об инцидентах."
			},
			{
				title: "9. Локализация и трансграничная передача",
				text: "9.1. При сборе персональных данных граждан Российской Федерации с использованием сети Интернет запись, систематизация, накопление, хранение, уточнение и извлечение таких данных осуществляются с использованием баз данных, находящихся на территории Российской Федерации, за исключением случаев, предусмотренных законом."
			},
			{
				title: "10. Сроки обработки, прекращение обработки и уничтожение",
				text: "10.1. Персональные данные обрабатываются до достижения целей, истечения срока согласия, прекращения договора, отзыва согласия либо наступления иного законного основания для прекращения обработки, если дальнейшее хранение не требуется по закону или для защиты прав Оператора и третьих лиц.\n" +
					"\n" +
					"10.2. При достижении целей обработки либо утрате необходимости в их достижении данные уничтожаются или обезличиваются в сроки, установленные законодательством. Если немедленное уничтожение невозможно, данные блокируются и уничтожаются в установленный срок.\n" +
					"\n" +
					"10.3. Уничтожение производится способом, исключающим восстановление содержания персональных данных, с оформлением подтверждающих документов в случаях, предусмотренных законодательством и локальными актами Оператора."
			},
			{
				title: "11. Права субъекта персональных данных",
				text: "<ul>\n" +
					"<li>получать сведения об обработке своих персональных данных;</li>" +
					"<li>требовать уточнения, блокирования или уничтожения данных, если они неполные, устаревшие, неточные, незаконно полученные или избыточные;</li>" +
					"<li>отзывать согласие на обработку персональных данных;</li>" +
					"<li>требовать прекращения обработки в случаях, предусмотренных законом;</li>" +
					"<li>возражать против получения рекламных сообщений и отказаться от рассылки;</li>" +
					"<li>обжаловать действия или бездействие Оператора в Роскомнадзор или в суд;</li>" +
					"<li>осуществлять иные права, предусмотренные законодательством Российской Федерации;</li>" +
					"</ul>"
			},
			{
				title: "12. Порядок направления обращений",
				text: "12.1. Обращение может быть направлено по почтовому адресу Оператора: г. Красноярск, ул. Калинина, 53, стр. 19, кабинет 1 либо через форму обратной связи, размещенную на Сайте.\n" +
					"\n" +
					"12.2. Обращение должно позволять идентифицировать заявителя и подтверждать наличие отношений с Оператором. Оператор вправе запросить дополнительные сведения, необходимые для проверки полномочий и предотвращения неправомерного раскрытия данных.\n" +
					"\n" +
					"12.3. Оператор рассматривает обращения и направляет ответ в сроки, установленные законодательством Российской Федерации. Для отдельных требований законом могут устанавливаться специальные сокращенные сроки."
			},
			{
				title: "13. Меры по обеспечению безопасности персональных данных",
				text: "Оператор принимает необходимые и достаточные правовые, организационные и технические меры, в том числе:\n" +
					"<ul>\n" +
					"<li>назначает лицо, ответственное за организацию обработки персональных данных;</li>" +
					"<li>утверждает локальные акты, модели угроз, правила доступа, резервного копирования, реагирования на инциденты и уничтожения данных;</li>" +
					"<li>определяет угрозы безопасности и применяет меры защиты, соответствующие установленному уровню защищенности;</li>" +
					"<li>ограничивает и регистрирует доступ, применяет аутентификацию, управление правами, шифрование и журналирование, когда это необходимо;</li>" +
					"<li>проводит оценку эффективности мер защиты, внутренний контроль и обучение работников;</li>" +
					"<li>обеспечивает обнаружение инцидентов, восстановление данных и взаимодействие с уполномоченным органом в предусмотренных законом случаях;</li>" +
					"<li>заключает с работниками и подрядчиками обязательства о конфиденциальности и контролирует соблюдение требований.</li>" +
					"</ul>"
			},
			{
				title: "14. Обработка данных несовершеннолетних",
				text: "Сервисы не предназначены для целенаправленного сбора персональных данных детей, если иное прямо не указано в соответствующем сервисе. При выявлении обработки данных несовершеннолетнего без надлежащего правового основания Оператор принимает меры к прекращению обработки и удалению таких данных."
			},
			{
				title: "15. Актуализация Политики",
				text: "15.1. Оператор вправе изменять Политику при изменении законодательства, состава Сервисов, целей, способов и технологий обработки. Новая редакция действует с момента ее размещения на Сайте, если в ней не указан иной срок.\n" +
					"\n" +
					"15.2. Существенные изменения могут доводиться до пользователей через интерфейс Сервисов, e-mail или иным доступным способом."
			},
			{
				title: "16. Заключительные положения",
				text: "16.1. Во всем, что не урегулировано Политикой, Оператор руководствуется законодательством Российской Федерации.\n" +
					"\n" +
					"16.2. Политика является публичным документом. Доступ к ней должен быть обеспечен непосредственно на страницах Сайта и иных Сервисов, где осуществляется сбор персональных данных."
			}
		],
	}),
	getters: {
		POLITIC(state) {
			return state.politic
		},
	}
}